/* eslint no-unused-vars: 0 */
import $ from 'jquery';

import GiftPopup from './gift-popup.js';
import initScrollTo from './scroll-to';
import search, {SearchLink} from './search';
import mobileMenu from './mobile-menu';
import sideMenu from './sidemenu';
import area from './area.js';
import tabs from './tabs.js';
import nav from './nav.js';
import mega from './mega.js';
import toggler from './toggler.js';
import copy from './copy.js';
import lazyLoad from './lazy-load.js';
import parallaxWave from './parallax-wave.js';
import newsletter from './newsletter.js';
import initCookiePopup from './cookie-popup';
import initNoticePopup from './notice-popup';
import modal from './modal';
import reportNav from './report-nav';
import embedMessage from './embed-message';
import scrollyTelling from './scrolly-telling';
import gallerySlider from './gallery-slider';
import video from './video';
import expandableContent from './expandable-content';
import map from './map';

$(document).ready(() => {

    const $scrollTo = $('.js-scroll-to');
    if ($scrollTo.length) {
        $scrollTo.map((i, v) => initScrollTo(v));
    }

    const $search = $('.js-search');
    if ($search.length) {
        $search.map((i, v) => search(v));
    }

    const $searchLink = $('.js-search-link');
    if ($searchLink.length) {
        $searchLink.map((i, v) => SearchLink(v));
    }

    const $jsMobileMenu = $('.js-toggle-menu');
    if ($jsMobileMenu.length) {
        $jsMobileMenu.map((i, v) => mobileMenu(v));
    }

    const $jsSideMenu = $('.js-sidemenu');
    if ($jsSideMenu.length) {
        $jsSideMenu.map((i, v) => sideMenu(v));
    }

    const $area = $('.js-area');
    if ($area.length) {
        $area.map((i, v) => area(v));
    }

    const $tabs = $('.js-tab');
    if ($tabs.length) {
        $tabs.map((i, v) => tabs(v));
    }

    const $nav = $('.js-toggle-nav');
    if ($nav.length) {
        $nav.map((i, v) => nav(v));
    }

    const $mega = $('.js-mega');
    if ($mega.length) {
        $mega.map((i, v) => mega(v));
    }

    const $toggler = $('.js-toggle');
    if ($toggler.length) {
        $toggler.map((i, v) => toggler(v));
    }

    const $copy = $('.js-copy');
    if ($copy.length) {
        $copy.map((i, v) => copy(v));
    }

    const $lazy = $('.js-lazy');
    if ($lazy.length) {
        $lazy.map((i, v) => lazyLoad(v));
    }

    const $parallaxWave = $('.js-parallax-wave');
    if ($parallaxWave.length) {
        $parallaxWave.map((i, v) => parallaxWave(v));
    }

    const $newsletter = $('.js-newsletter');
    if ($newsletter.length) {
        $newsletter.map((i, v) => newsletter(v));
    }

    const $cookiePopup = $('.js-cookie-popup');
    if ($cookiePopup.length) {
        $cookiePopup.map((i, v) => initCookiePopup(v));
    }

    const $noticePopup = $('.js-notice-popup');
    if ($noticePopup.length) {
        $noticePopup.map((i, v) => initNoticePopup(v));
    }

    const $modal = $('.js-gallery-modal');
    if ($modal.length) {
        $modal.map((i, v) => modal(v));
    }

    const $reportNav = $('.js-report-nav');
    if ($reportNav.length) {
        $reportNav.map((i, v) => reportNav(v));
    }

    const $embedMessage = $('.js-embed-message');
    if ($embedMessage.length) {
        $embedMessage.map((i, v) => embedMessage(v));
    }

    const $scrollyTelling = $('.js-scrollytelling');
    if ($scrollyTelling.length) {
        $scrollyTelling.map((i, v) => scrollyTelling(v));
    }

    const $gallerySlider = $('.js-gallery-slider');
    if ($gallerySlider.length) {
        $gallerySlider.map((i, v) => gallerySlider(v));
    }

    const $giftPopup = $('.js-gift-popup');
    if ($giftPopup.length) {
        $giftPopup.map((i, v) => GiftPopup(v));
    }

    const $video = $('.js-video');
    if ($video.length) {
        $video.map((i, v) => video(v));
    }

    const $expandableContent = $('.js-expand');
    if ($expandableContent.length) {
        $expandableContent.map((i, v) => expandableContent(v));
    }

    const $map = $('.js-map');
    if ($map.length) {
        $map.map((i, v) => map(v));
    }
});

const $gift = $('#gift-app');
if ($gift.length) {
    // Load the Vue-based gift app (and Vue/Vuelidate) only on gift pages.
    import('./gift/app')
        .then(({ default: Gift }) => Gift('#gift-app'))
        .catch(err => console.error('[gift] failed to load/mount gift app:', err));
}

const $thankyou = $('#gift-thankyou');
if ($thankyou.length) {
    import('./gift/thankyou')
        .then(({ default: GiftThankyou }) => GiftThankyou($thankyou))
        .catch(err => console.error('[gift] failed to load/mount thankyou:', err));
}
